import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DayViewHourSegment } from 'calendar-utils';


export class CalendarDayViewHourSegmentComponent {

   segment: DayViewHourSegment;

   locale: string;

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mwl-calendar-day-view-hour-segment',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="cal-hour-segment" [ngClass]="segment.cssClass">
      <div [hidden]="!segment.isStart" class="cal-time">
        {{ segment.date | calendarDate:'dayViewHour':locale }}
      </div>
      &nbsp;
    </div>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'segment': [{ type: Input },],
'locale': [{ type: Input },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
